import { Component, OnInit, AfterViewChecked, AfterViewInit, OnDestroy } from '@angular/core';
import { BreadcrumbService } from '../../../breadcrumb/breadcrumb.service';
import { Subscription, Subject } from 'rxjs';
import { StateService } from '../state.service';
import { MAT_CHECKBOX_CLICK_ACTION } from '@angular/material';

@Component({
    selector: 'app-assignment-pvb',
    templateUrl: './assignment-pvb.component.html',
    styleUrls: ['./assignment-pvb.component.scss']
})
export class AssignmentPvbComponent implements OnInit, AfterViewInit, OnDestroy {

    public administrationSuccess = false;
    public asssignmentSuccess = false;
    public signingSuccess = false;

    private destroy$: Subject<boolean> = new Subject<boolean>();


    constructor(private breadcrumbService: BreadcrumbService, private stateService: StateService) { }


    ngOnInit() {
        this.stateService.administrationUpdate$
        .takeUntil(this.destroy$)
        .subscribe(data => {
            this.administrationSuccess = data;
        });

        this.stateService.assignmentUpdate$
        .takeUntil(this.destroy$)
        .subscribe(data => {
            this.asssignmentSuccess = data;
        });

        this.stateService.signingUpdate$
        .takeUntil(this.destroy$)
        .subscribe(data => {
            this.signingSuccess = data;
        })
    }

    ngAfterViewInit() {
        setTimeout(() => {
            this.breadcrumbService.examinationPreparationForm('Opdracht Proeve van Bekwaamheid');
        });
    }

    ngOnDestroy() {
        this.destroy$.next(false);
    }
}



// WEBPACK FOOTER //
// ./src/app/exam-preparation/assignment-pvb/assignment-pvb/assignment-pvb.component.ts